import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Particle, PendParticleResponse } from '@newgenus/common';
import { Component, Inject } from '@angular/core';

@Component({
    selector: 'newgenus-pend-particle-display-modal',
    templateUrl: './pend-particle-display-modal.component.html',
    styleUrls: ['./pend-particle-display-modal.component.scss'],
    standalone: false,
})
export class PendParticleDisplayModalComponent {
    /** 1-based month, matching the stored PendParticleResponse contract. */
    public model: { year: number; month: number; day: number };
    public time = { hour: 12, minute: 0 };
    public noteText = '';

    constructor(
        public dialogRef: MatDialogRef<PendParticleDisplayModalComponent, PendParticleResponse>,
        @Inject(MAT_DIALOG_DATA) public particle: Particle
    ) {
        // Default: 30 minutes from now (rounded to the minute).
        this.setFromDate(new Date(Date.now() + 30 * 60_000));
    }

    /** datetime-local value <-> model/time, e.g. "2026-06-11T14:30". */
    public get pendDateTimeLocal(): string {
        const pad = (n: number) => String(n).padStart(2, '0');
        return `${this.model.year}-${pad(this.model.month)}-${pad(this.model.day)}T${pad(this.time.hour)}:${pad(this.time.minute)}`;
    }

    public onDateTimeChange(value: string): void {
        if (!value) return;
        const parsed = new Date(value);
        if (isNaN(+parsed)) return;
        this.setFromDate(parsed);
    }

    private setFromDate(date: Date): void {
        this.model = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
        this.time = { hour: date.getHours(), minute: date.getMinutes() };
    }

    /** Current pend moment as a Date (model.month is 1-based). */
    private currentAsDate(): Date {
        return new Date(this.model.year, this.model.month - 1, this.model.day, this.time.hour, this.time.minute, 0);
    }

    public setPendingTimePlusThirtyMinutes(): void {
        this.setFromDate(new Date(this.currentAsDate().getTime() + 30 * 60_000));
    }

    public setPendingTimePlusOneHour(): void {
        this.setFromDate(new Date(this.currentAsDate().getTime() + 60 * 60_000));
    }

    public setPendingTimePlusOneDay(): void {
        this.setFromDate(new Date(this.currentAsDate().getTime() + 24 * 60 * 60_000));
    }

    public setPendingTimeTomorrowMorning(): void {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(9, 0, 0, 0);
        this.setFromDate(tomorrow);
    }

    public submit(): void {
        const args: PendParticleResponse = {
            particle: this.particle,
            model: this.model,
            time: this.time,
            noteContent: this.noteText?.trim() ? this.noteText : undefined,
        };
        this.dialogRef.close(args);
    }
}
